import { hasOptionField, isSelectField } from '../types/helpers';
import { AppStructureBuilderError } from './error';
export function addPreview({ previewName, fieldName, formName, entityName }) {
    this.updateAppStructure(draftBuilder => {
        draftBuilder.application.previews[previewName] = draftBuilder.getPreview(previewName) ?? this.newPreview({ previewName, entityName });
        if (fieldName && formName) {
            const form = draftBuilder.getForm(formName);
            if (!form) {
                throw new AppStructureBuilderError(`Form ${formName} not found`);
            }
            const field = form.fields[fieldName];
            if (!field) {
                throw new AppStructureBuilderError(`Field ${fieldName} not found in form ${formName}`);
            }
            if (!hasOptionField(field)) {
                // TODO: fix this when removing fields
                // throw new AppStructureBuilderError(`Field ${fieldName} is not a select. ${JSON.stringify(field)}`)
                return;
            }
            form.fields[fieldName] = { ...field, optionField: previewName };
        }
    });
    return this;
}
export function removePreview(previewName) {
    this.updateAppStructure(draftBuilder => {
        delete draftBuilder.application.previews[previewName];
    });
    return this;
}
export function removePreviewFromForm({ previewName, formName }) {
    this.updateAppStructure(draftBuilder => {
        const form = draftBuilder.getForm(formName);
        if (!form) {
            throw new AppStructureBuilderError(`Form ${formName} not found`);
        }
        const field = form.fields[previewName];
        if (!field) {
            throw new AppStructureBuilderError(`Field ${previewName} not found in form ${formName}.`);
        }
        if (!isSelectField(field)) {
            throw new AppStructureBuilderError(`Field ${previewName} is not a select.`);
        }
        form.fields[previewName] = { ...field, optionField: undefined };
    });
    return this;
}
export function addPreviewField({ previewFieldName, previewName }) {
    this.updateAppStructure(draftBuilder => {
        const preview = draftBuilder.getPreview(previewName);
        if (!preview) {
            throw new AppStructureBuilderError(`Preview ${previewName} not found. You must add the preview to the application before adding fields.`);
        }
        draftBuilder.application.previews[previewName] = draftBuilder.application.previews[previewName] ?? preview;
        const modelField = { ...draftBuilder.getEntityField(preview.entityName, previewFieldName) };
        preview.fields[previewFieldName] = { field: previewFieldName, name: previewFieldName, modelField };
    });
    return this;
}
export function removePreviewField({ previewFieldName, previewName }) {
    this.updateAppStructure(draftBuilder => {
        const preview = draftBuilder.getPreview(previewName);
        if (!preview) {
            throw new AppStructureBuilderError(`Preview ${previewName} not found`);
        }
        if (!preview.fields[previewFieldName]) {
            throw new AppStructureBuilderError(`Field ${previewFieldName} not found in preview ${previewName}`);
        }
        delete preview.fields[previewFieldName];
    });
    return this;
}
//# sourceMappingURL=previewManagement.js.map